import { FC, ReactElement } from "react";
import WhoCard from "../../components/WhoCard";
import { Box } from "@mui/material";

const About: FC = (): ReactElement => {
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexDirection: 'row' }}>
        <WhoCard name={'Paulo Quaresma'} role={'Full Professor'} email={'pq@uevora.pt'} image={'/images/PQ_foto.jpg'} imageTitle="Paulo Quaresma" />
        <WhoCard name={'Vítor Beires Nogueira'} role={'Associate Professor'} email={'vbn@uevora.pt'} image={'/images/VN_foto.jpg'} imageTitle="Vítor Beires Nogueira" />
        <WhoCard name={'Arminda Guerra'} role={'Research Fellow'} email={'arminda.lopes@m-iti.org'} image={'/images/AG_foto.jpg'} imageTitle="Arminda Guerra" />
        <WhoCard name={'Daniela Schmidt'} role={'Assistant Teacher'} email={'daniela.schmidt@uevora.pt'} image={'/images/DaS_foto.jpg'} imageTitle="Daniela Schmidt" />
      </Box >
      <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexDirection: 'row' }}>
        <WhoCard name={'Nuno Miquelina'} role={'PhD Student'} email={'nuno.miquelina@gmail.com'} image={'/images/NM_Foto.jpg'} imageTitle="Nuno Miquelina" />
        <WhoCard name={'Daniel Santos'} role={'Guest Research Assistant'} email={'dfsantos@uevora.pt'} image={'/images/DS_foto.jpg'} imageTitle="Daniel Santos" />
        <WhoCard name={'Miguel Silvério'} role={'Master Student'} email={'mavsilveriowork@gmail.com'} image={'/images/MS_foto.jpeg'} imageTitle="Miguel Silvério" />
      </Box >
    </>
  );
};

export default About;
